import { axiosInstance } from './common';

export const getManifest = () =>
  axiosInstance.get('/docs').then((r) => r.data);

export const getArticle = (slug) =>
  axiosInstance.get(`/docs/${slug}`).then((r) => r.data);

export const downloadWorkbook = () =>
  axiosInstance
    .get('/docs/workbook.xlsm', { responseType: 'blob' })
    .then((r) => {
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'workbook.xlsm';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    });
